import { IRole } from '../model/role';

export function doesUserHasPermission(
  userPermissions: IRole[],
  permissionIds?: string[],
): boolean {
  if (permissionIds?.length) {
    const userPermissionsSet = new Set<string>();

    for (const permission of userPermissions.flatMap((role) => role.permissions ?? [])) {
      if (typeof permission === 'string') {
        userPermissionsSet.add(permission);
        continue;
      }

      if (!permission || typeof permission !== 'object') {
        continue;
      }

      // Add both code and numeric id forms so callers can check either.
      if ('code' in permission && typeof permission.code === 'string' && permission.code) {
        userPermissionsSet.add(permission.code);
      }

      if ('permissionId' in permission && permission.permissionId !== undefined && permission.permissionId !== null) {
        userPermissionsSet.add(permission.permissionId.toString());
      }

      if ('id' in permission && permission.id !== undefined && permission.id !== null) {
        userPermissionsSet.add(permission.id.toString());
      }
    }

    return permissionIds.some((p) => userPermissionsSet.has(p));
  }

  return true;
}

export function doesUserHasAllPermissions(
  userPermissions: IRole[],
  permissionIds?: string[],
): boolean {
  if (!permissionIds?.length) {
    return true;
  }

  return permissionIds.every((permissionId) =>
    doesUserHasPermission(userPermissions, [permissionId]),
  );
}
